import { PermitableTypes } from 'enum/permissionsTypes.enum'

export interface ICoursePermissions {
  canAnswer: boolean
  canDownload: boolean
  canEdit: boolean
  canMonitor: boolean
  canRequest: boolean
  canManageCourses: boolean
  id: number
  loading: boolean
  permissionType: PermitableTypes
}

export interface IAccessModel {
  courses: Record<number, ICoursePermissions>
}

export const coursePermissionsInitialState: ICoursePermissions = {
  canAnswer: false,
  canDownload: false,
  canEdit: false,
  canMonitor: false,
  canRequest: false,
  id: 0,
  loading: false,
  canManageCourses: false,
  permissionType: PermitableTypes.Course,
}
